// extracted by mini-css-extract-plugin
module.exports = {"jobList":"careers-module--jobList--2S0yE","deptName":"careers-module--deptName--1T7YY","dept":"careers-module--dept--3KP9Z"};